var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5 7.5H9.5V1.5C9.5 0.947 9.052 0.5 8.5 0.5C7.948 0.5 7.5 0.947 7.5 1.5V7.5H1.5C0.948 7.5 0.5 7.947 0.5 8.5C0.5 9.053 0.948 9.5 1.5 9.5H7.5V15.5C7.5 16.053 7.948 16.5 8.5 16.5C9.052 16.5 9.5 16.053 9.5 15.5V9.5H15.5C16.052 9.5 16.5 9.053 16.5 8.5C16.5 7.947 16.052 7.5 15.5 7.5Z",
    fill: "#191C1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/Plus.c9e3633febc4eb67ad7168ab81b23b37.svg";
export { ForwardRef as ReactComponent };